import { t } from '../i18n'

export const OPTIONS_YES_NO = {
  yes: t('general.yes'),
  no: t('general.no'),
} as const
